import Axios from 'axios';
import { Service, ServiceType } from "@/common/Service";
import BetterJs from "@/common/BetterJs";
import { ServiceParams, GetServiceParams, SaveServiceParams } from "@/common/HttpService/statement";

export default class HttpService {

  /**
   * 获取当前页面配置并初始化
   */
  static async getConfig () {
    window.lockSubmit = false;
    let res = await Axios.get<BaseConfig>('/config.json')
    window.baseConfig = res.data;
    if (window.baseConfig.currentUser) {
      const userName= sessionStorage.getItem("userName");
      const userId= sessionStorage.getItem("userId");
      window.baseConfig.currentUser.name = userName || (window.baseConfig.currentUser.name || '') 
      window.baseConfig.currentUser.userid = userId || (window.baseConfig.currentUser.userid || '')  
    }
    if (!window.baseConfig.development) {
      BetterJs.init({
        sendError: (error) => {
          Service.writeLog(error)
        }
      })
    }
    return
  }

  /** 获取权限 */
  static getController<T> (params: ServiceParams) {
    return Service.executeService<T>({
      name: '/service/controller/GetController?_ajax=1',
      params
    })
  }

  static GetIds () {
    return Service.executeService<string[]>({
      name: '/service/data/GetIds?_ajax=1',
      params: {count: 1}
    })
  }
  
  /** 获取页面数据 */
  static getPageData<T> (params: GetServiceParams) {
    return Service.executeService<T>({
      name: '/service/data/getpagedata?_ajax=1',
      params
    })
  }

  /** 保存页面数据 */
  static getData<T> (params: SaveServiceParams) {
    return Service.executeService<T>({
      name: '/service/controller/execute?_ajax=1',
      params
    })
  }

  /** 保存页面数据 */
  static executeController<T> (params: SaveServiceParams) {
    return Service.executeService<T>({
      name: '/service/controller/execute?_ajax=1',
      params
    }, ServiceType.Post)
  }
  
  static config2DingTalk (corpId: string) {
    return Service.executeService<DingtalkConfig>({
      name: '/service/ding/config',
      params: {
        corpId: corpId,
        // url:  window.location.href
        url: encodeURIComponent(window.location.href)
      }
    })
  }

  static login2DingTalk (corpId: string, code: string) {
    return Service.executeService<{rights: {[key: string]: string}, success: boolean}>({
      name: '/service/ding/login',
      params: {
        corpId: corpId,
        code: code
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/common/HttpService/index.ts